import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  root: {
    width: '94%',
    padding: '3% 3% 1.5%',
  },
}));
